var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBarGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7002 42V9H28.7002V42H22.7002V21H10.7002V42H6.2002V3H3.2002V42C3.2002 42.8 3.5202 43.56 4.0802 44.12C4.6402 44.68 5.4002 45 6.2002 45H45.2002V42H40.7002ZM19.7002 42H13.7002V24H19.7002V42ZM37.7002 42H31.7002V12H37.7002V42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBarGraph);
export default __webpack_public_path__ + "static/media/ic-bar-graph.0d3cf0396329e19d2fbb8100e0af4a38.svg";
export { ForwardRef as ReactComponent };